// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect, useState } from "react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import "./Dashboard.css";
import GCRRebateOptimizerTool from "../../component/dashboard/GCRRebateOptimizerTool ";
import { userAuthAction } from "../../redux/action/authAction";
import { useDispatch } from "react-redux";
import { CalculatorOutlined } from "@ant-design/icons";

// Root Component to demonstrate usage of wrapper component
function Dashboard() {
  // PowerBI Report object (to be received via callback)
  const [, setReport] = useState();
  const [calModal, setcalModal] = useState(false);
  const dispatch = useDispatch();

  // API end-point url to get embed config for a sample report
  // old 2024
  // const sampleReportUrl =
  //   "https://app.powerbi.com/view?r=eyJrIjoiNmJhM2RkN2EtMzlmZC00M2UyLTk3ZTktMWNlYThlMzM2NWI5IiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9";
 
  // new 2025
  const sampleReportUrl =""

 
    // const sampleReportUrl =
  //   "https://app.powerbi.com/view?r=eyJrIjoiYzliNzRkMjAtNzQxOS00NWM1LWI4MTktYzg2OTMyYTIxMzJjIiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9";

  // "https://app.powerbi.com/view?r=eyJrIjoiNTEyNTZiYTEtMmQ0MS00MGUzLWIxMDYtNTRhZGQxYzAyZWNjIiwidCI6IjQxMThmNWJlLTg5NmQtNGJhZi05ZTdiLTYwOTUwNzE5ZWIwYSIsImMiOjN9";
  // Report config useState hook
  // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below
  const [sampleReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: sampleReportUrl,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  });

  // Map of event handlers to be applied to the embedding report
  const eventHandlersMap = new Map([
    [
      "loaded",
      function () {
        console.log("Report has loaded");
      },
    ],
    [
      "rendered",
      function () {
        console.log("Report has rendered");

        // Update display message
        setMessage("The report is rendered");
      },
    ],
    [
      "error",
      function (event) {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  // Fetch sample report's config (eg. embedUrl and AccessToken) for embedding
  const mockSignIn = async () => {
    // Fetch sample report's embed config

    fetch(sampleReportUrl)
      .then(async (res) => {
        const reportConfig = await res.json();
        setReportConfig({
          ...sampleReportConfig,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: false,        
            panes: {
              filters: {
                expanded: false,
                visible: false
              }
            }
          },          
          embedUrl: reportConfig.EmbedUrl,
          accessToken: reportConfig.EmbedToken.Token,
        });
      })
      .catch((e) => console.log(e));
  };
  const changeSettings = () => {
    // Update the state "sampleReportConfig" and re-render DemoApp component
    setReportConfig({
      ...sampleReportConfig,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        panes: {
          filters: {
            expanded: false,
            visible: false,
          },
        },
      },
    });
  };

  const [displayMessage, setMessage] = useState(
    `The report is bootstrapped. Click the Embed Report button to set the access token`
  );

  const controlButtons = (
    <div className="controls">
      <button onClick={mockSignIn}>Embed Report</button>

      <button onClick={changeSettings}>Hide filter pane</button>
    </div>
  );

  const header = (
    <div className="header">
      <div className="title">Power BI React component demo</div>
    </div>
  );

  useEffect(() => {
    // mockSignIn()
  }, []);

  useEffect(() => {
    dispatch(userAuthAction(() => {}));
  }, []);

  return (
    <div>
      {/* {header} */}
      <GCRRebateOptimizerTool
        visible={calModal}
        onHide={() => setcalModal(false)}
      />
      {/* <div className=" mt-3 mb-3 gap-4 flex cursor-pointer justify-center items-center ">
        <CalculatorOutlined />
        <p onClick={() => setcalModal(true)} className="m-0">
          GCR Rebate Optimizer Tool
        </p>
      </div> */}
      <PowerBIEmbed
        embedConfig={{ 
          type: "report",
          embedUrl: sampleReportUrl,      
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: false,
            panes: {
              filters: {
                expanded: false,
                visible: false
              }
            }
          }
        }}
        eventHandlers={eventHandlersMap}
        cssClassName={"report-style-class"}
        getEmbeddedComponent={(embedObject) => {
          console.log(
            `Embedded object of type "${embedObject.embedtype}" received`
          );
          setReport(embedObject);
        }}
      />
    </div>
  );
}

export default Dashboard;
